export default state => {
	if (state.claims) {
		return Object.values(state.claims).filter(claim => {
			return claim.claimed_by === null || claim.claimed_by === state.user.walletAddress;
		});
	} else {
		return [];
	}
};
